<template>
  <div class="container">
    <template v-if="!isEstabelecimento">
      <div class="row">
        <div class="col-md-3">
          <label class="text text-primary">Conformidade com o projeto</label>
          <select-component
            name="conformidade_projeto"
            v-model="conformity"
            @change="val => (conformity = val)"
          >
            <option value="">SELECIONE</option>
            <option value="CONFORME">Conforme</option>
            <option value="DESCONFORME">Desconforme</option>
          </select-component>
        </div>
      </div>
      <div class="row" v-if="conformity === 'DESCONFORME'">
        <div class="col-md-9">
          <div class="form-group required">
            <label for="motivo_desconforme">Motivo</label>
            <input
              type="text"
              name="motivo_desconforme"
              id="motivo_desconforme"
              class="form-control"
              :value="motivo_desconforme"
              accept="application/pdf"
            />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="anexo_desconforme">Anexo</label>
            <input
              type="file"
              name="documentos[anexo][6]"
              id="anexo_desconforme"
              class="form-control"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row">
        <div class="col-md-3">
          <label class="text text-primary">Conformidade com o projeto</label>
          <span class="text">{{ conformity }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    isEstabelecimento: {
      required: true
    },
    conformidade_projeto: {
      required: true,
    },
    motivo_desconforme: {
      required: true,
    }
  },
  data: () => ({
    conformity: ""
  }),
  mounted() {
    this.conformity = this.conformidade_projeto;
  }
};
</script>
